import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { type OrderingLedger } from '../../machine';
import { prepareLedger } from '../../utils';

export const usePaymentBreakdown = (params: UsePaymentBreakdownParams) => {
  const { amountEligibleForFlex, tip, availableCredit, shouldUseCredit, shouldUseFlex, ledger } =
    params;

  const { formatNumber } = useIntl();

  return useMemo(() => {
    const { amountPaidWithStripe } = prepareLedger({
      ledger,
      tip,
      availableCredit,
      shouldUseCredit,
      amountEligibleForFlex,
      shouldUseFlex,
    });

    return {
      stripeAmount: formatNumber(amountPaidWithStripe / 100, {
        style: 'currency',
        currency: 'USD',
      }),
      flexAmount: formatNumber((amountEligibleForFlex || 0) / 100, {
        style: 'currency',
        currency: 'USD',
      }),
    };
  }, [
    formatNumber,
    ledger,
    tip,
    availableCredit,
    shouldUseCredit,
    shouldUseFlex,
    amountEligibleForFlex,
  ]);
};

// ─── Types ──────────────────────────────────────────────────────────────────

type UsePaymentBreakdownParams = {
  amountEligibleForFlex: number | null;
  tip: number;
  availableCredit: number;
  shouldUseCredit: boolean;
  shouldUseFlex: boolean;
  ledger?: OrderingLedger;
};
